import { BInputError } from './index';

/**
 * Composant de champ de saisie personnalisé avec label
 * @param {Object} props - Les propriétés du composant
 * @param {'text' | 'date' | 'email' | 'number' | 'password' |'textarea'} [props.type='text'] - Le type de champ de saisie
 * @param {string} props.label - Le label affiché au-dessus du champ
 * @param {string} props.name - Le nom du champ pour les formulaires
 * @param {boolean} [props.isDirty=false] - Indique si le champ a été modifié
 * @param {boolean} [props.isHidden=false] - Indique si le champ doit être masqué
 * @param errors
 * @param children
 * @param placeholder
 * @param Icon
 * @returns {JSX.Element} Le composant de champ de saisie
 */
const BInput = ({
  type = 'text',
  label,
  name,
  isDirty = false,
  isHidden = false,
  placeholder = '',
  icon: Icon,
  children,
  errors,
  ...props
}) => {
  return (
    <div className={'flex w-full flex-col gap-1'} hidden={isHidden}>
      <p className={'text-sm font-normal text-slate-700'}>{label}</p>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3">
          {Icon && <Icon className={'size-4 text-slate-500'} />}
        </div>
        <input
          hidden={isHidden}
          className={`w-full max-w-full appearance-none py-3 ${Icon ? 'ps-8' : 'px-4'} focus:outline-primary-600 rounded-lg border border-slate-300 bg-slate-100 text-base leading-tight font-normal text-slate-600 placeholder-slate-400 focus:outline-2 disabled:opacity-80 ${isDirty ? 'italic' : 'normal'} `}
          name={name}
          type={type}
          placeholder={placeholder}
          {...props}
        />
        {children}
        <BInputError errors={errors} />
      </div>
    </div>
  );
};

export default BInput;
